<template>
  <div class="home">
    <!--
    <v-app-bar color="#1887b4" dark fixed>
      <router-link to="/">
        <img class="mr-3" src="~@/assets/logo.png" height="42" />
      </router-link>
      <v-toolbar-title class="d-none d-sm-block">
        <router-link to="/">{{title}}</router-link>
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-toolbar-items>
        <v-dialog v-model="dialog" max-width="400px">
          <template v-slot:activator="{ on }">
            <v-btn color="transparent" tile elevation="0" v-on="on">
              <v-icon left>mdi-login</v-icon>Entrar
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Dados de login</span>
            </v-card-title>
            <v-card-text>
              <v-alert type="error" v-if="errorMessage" color="red">{{errorMessage}}</v-alert>
              <v-text-field
                label="Passaporte*"
                name="inputPassaporte"
                v-model="dataLogin.passaporte"
                required
              ></v-text-field>
              <v-text-field
                :append-icon="showSenha ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showSenha ? 'text' : 'password'"
                name="inputSenha"
                label="Senha*"
                v-model="dataLogin.senha"
                @click:append="showSenha = !showSenha"
              ></v-text-field>
              <small>*Preenchimento obrigatório</small>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="blue darken-1" text @click="login()">Entrar</v-btn>
              <v-btn color="red darken-1" text @click="dialog = false">Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar-items>
    </v-app-bar>
    -->
    <v-main class="mt-0">
      <section>
        <v-parallax src="~@/assets/contabilidade.jpg" height="600">
          <v-layout column align-center justify-center class="white--text">
            <img src="~@/assets/logo.png" alt="Vuetify.js" height="200" class="mb-10" />
            <h1 class="white--text mb-2 display-1 text-center">Projetos Simplifica</h1>
            <span class="subheading text-center">Painel de Dados Estatísticos</span>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-layout column wrap class="my-12" align-center>
          <v-flex xs12 sm4 class="my-4">
            <div class="text-center">
              <h2 class="headline">Universidade Federal do Mato Grosso do Sul</h2>
              <span class="subheading">Pró-Reitoria de Planejamento, Orçamento e Finanças</span>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-content-space-between>
                <v-flex xs12 md4>
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="orange--text text--lighten-2">mdi-lifebuoy</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">Suporte</div>
                    </v-card-title>
                    <v-card-text style="min-height: 120px" class="text-center">
                      Para esclarecer eventuais dúvidas sobre o funcionamento do sistema ou reportar inconsistências, entre em contato pelo e-mail
                      <a
                        href="mailto:suporte.agetic@ufms.br"
                      >suporte.agetic@ufms.br</a> ou visite a página de
                      <a href="/ajuda" class>Ajuda</a>.
                    </v-card-text>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <div class="flex-grow-1"></div>
                    </v-card-actions>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="red--text text--lighten-2">mdi-lock</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">Com problemas para acessar?</div>
                    </v-card-title>
                    <v-card-text style="min-height: 120px" class="text-center">
                      No caso de acesso não autorizado, entre em contato pelo e-mail
                      <a
                        href="mailto:suporte.agetic@ufms.br"
                      >suporte.agetic@ufms.br</a> para que seja cadastrado no Sistema de Segurança.
                      Para definição ou recuperação de senha acesse o sistema do "Passaporte UFMS" pelo link a seguir:
                    </v-card-text>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn color="red" dark>Ir para o passaporte</v-btn>
                      <div class="flex-grow-1"></div>
                    </v-card-actions>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="green--text text--lighten-2">mdi-magnify</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">Acesso à área publica</div>
                    </v-card-title>
                    <v-card-text
                      style="min-height: 120px"
                      class="text-center"
                    >Para consultar informações universidade clique no botão abaixo</v-card-text>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn color="green" dark>Acesso a área publica</v-btn>
                      <div class="flex-grow-1"></div>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>
    </v-main>
    <v-footer dark padless>
      <v-layout align-center>
        <v-flex xs12>
          <v-card flat tile class="gray white--text text-center">
            <v-card-text class="pb-8">
              <v-btn v-for="imagem in imagens" :key="imagem" class="mx-4 white--text" icon>
                <v-img :src="imagem" max-height="50" max-width="50" contain />
              </v-btn>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text class="white--text pt-5">
              <span class="hidden-xs hidden-sm caption font-weight-thin">
                <strong class="font-weight-light d-none d-md-block">
                  AGETIC - Agência de Tecnologia da Informação e Comunicação
                  <br />UFMS - Universidade Federal de Mato Grosso do Sul
                </strong>
                <strong class="font-weight-light d-xs-block d-md-none">
                  AGETIC - UFMS
                  <br />
                </strong>
                <a href="https://agetic.ufms.br/servico_passaporte/" target="_blank">Clique aqui</a> para mais informações sobre o Passaporte UFMS
                <br />Para obter suporte: (067) 3345-7292
                <br />Segunda a sexta das 07:00 às 11:00 - 13:00 às 17:00
              </span>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-footer>
  </div>
</template>
<script>
import authService from "../services/authService";

export default {
  data: () => ({
    title: "Template Vue.js",
    dialog: false,
    showSenha: false,
    errorMessage: null,
    dataLogin: {
      passaporte: "",
      senha: ""
    },
    imagens: [
      require("../assets/logo-agetic-small.png"),
      require("../assets/logo-ufms.png")
    ]
  }),
  methods: {
    async login() {
      await authService.authentication()
    },
    complete(index) {
      this.list[index] = !this.list[index];
    }
  }
};
</script>
